import companyConfig from '@/company_config.json';

var clientId=companyConfig.clientId;
// console.log('companyConfig'+JSON.stringify(companyConfig)+', navbar clientId='+clientId);
var data = [];
if (clientId != "") {

	data = [

		// Ledgers
		{index: 0, label: 'Ledgers', url: '/ledgers/ledger/lists', labelIcon: 'LayersIcon', highlightAction: true},
	
		// Ledger Group
		{index: 1, label: 'Ledger Groups', url: '/ledgers/group/lists', labelIcon: 'ArchiveIcon', highlightAction: true},
	
		// Suppliers
		{index: 2, label: 'Suppliers', url: '/suppliers/lists', labelIcon: 'UsersIcon', highlightAction: true},
	
		// Price Group
		{index: 3, label: 'Price Group', url: '/party/pricegroups/list', labelIcon: 'TrendingUpIcon', highlightAction: true},
	
		// Products
		{index: 4, label: 'Products', url: '/products/lists', labelIcon: 'PackageIcon', highlightAction: true},
	
		// Product Price Update
		{index: 5, label: 'Price Update', url: '/products/price', labelIcon: 'InfoIcon', highlightAction: true},
	
		// Purchase
		{index: 6, label: 'Purchase List', url: '/purchase/lists', labelIcon: 'TruckIcon', highlightAction: true},
		{index: 7, label: 'Purchase Create', url: '/purchase/create', labelIcon: 'BriefcaseIcon', highlightAction: true},
	
		// Sales
		{index: 8, label: 'Sales List', url: '/sales/lists', labelIcon: 'ShoppingCartIcon', highlightAction: true},
		{index: 9, label: 'Sales Create', url: '/sales/create', labelIcon: 'ShoppingBagIcon', highlightAction: true},
	
		// Transaction
		{index: 10, label: 'Transaction', url: '/transaction/lists', labelIcon: 'ListIcon', highlightAction: true},
	];

	if (clientId == 12 || clientId == 13) {

		data.push(
			{
				index: 11,
				label: 'Production',
				url: '/production/lists',
				labelIcon: 'ListIcon',
				highlightAction: true
			}
		);
	
	}	
}

// console.log('data='+JSON.stringify(data));

export default {
	actionIcon: 'StarIcon',
	highlightColor: 'warning',
	data: data
}